import React from 'react';
import { Form, Input, Button } from 'antd';
import '../FreemanRegistration.css';
import useAuth from '../../../../../hooks/useAuth';

const LoginSection = () => {
  const { login } = useAuth();
  
  const onFinish = (values) => {
    login({...values, orgId: 'FREEMAN'})
  };

  return (
    <div className="login-container">
      <div className="login-title">Enter Login Credentials</div>

      <Form
        name="login-form"
        onFinish={onFinish}
        autoComplete="off"
        layout="vertical"
        className="login-form"
      >
        <Form.Item
          label="User ID"
          name="userid"
          // rules={[{ required: true, message: 'Please input your User ID!' }]}
          className="form-item"
        >
          <Input className="login-input" />
        </Form.Item>

        <Form.Item
          label="Password"
          name="password"
          // rules={[{ required: true, message: 'Please input your Password!' }]}
          className="form-item"
        >
          <Input.Password className="login-input" />
        </Form.Item>

        <div className="forgot-password">
          <a href="#">Forget Password</a>
        </div>

        <Form.Item>
          <Button type="primary" htmlType="submit" className="login-button">
            Login
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default LoginSection;